import React from "react";
import {useEffect, useState} from "react";
import {TagCloud} from "react-tagcloud/lib/TagCloud";
import "./AboutUs.css";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import MobNavbar from "../custom/MobNavbar";
import Navbar from "../custom/Navbar";

function AboutUs(props) {

    return (
        <>
            <div style={{backgroundColor: props.darkMode ? "rgb(17 24 39)" : "darkcyan"}} className="main" id="aboutMe">
                <div className="container-fluid">
                    <div className="main-about">
                        <div>


                            <h3>My Experience:</h3>
                            <div>
                                I have embarked on an exciting journey in the world of web development and have
                                successfully
                                completed various full-stack projects utilizing the MERN (MongoDB, Express.js, React.js,
                                Node.js) stack. My projects are a testament to my proficiency in crafting efficient,
                                scalable, and user-friendly web applications. From back-end database management to
                                front-end
                                design, I strive to ensure every component of the application functions seamlessly,
                                leaving
                                no room for compromise.

                                In addition to my project work, I actively participated and successfully completed
                                Hacktoberfest 2022, where I collaborated with developers worldwide, honing my teamwork
                                and
                                problem-solving skills. This enriching experience not only allowed me to contribute to
                                the
                                open-source community but also exposed me to diverse perspectives and approaches in the
                                field of software development.
                            </div>
                        </div>

                        <div>

                            <h3>My Internship at Amazon India:</h3>

                            <div>

                                During my 3-year summer break, I was fortunate enough to secure an internship at Amazon
                                India, a leading global tech giant. The experience was nothing short of transformative,
                                as I
                                got the opportunity to work on real-world projects and contribute to large-scale
                                applications. The exposure to Amazon's work culture, coupled with the guidance from
                                seasoned
                                professionals, significantly accelerated my growth as a developer.

                            </div>
                        </div>

                        <div>

                            <h3>The Present and Beyond:</h3>


                            <div>As I enter my fourth year, I am more excited than ever to leverage my skills and
                                experiences to help businesses like yours thrive. I am a firm believer in continuous
                                learning and always strive to stay up-to-date with the latest trends and technologies in
                                the
                                rapidly evolving world of web development.
                            </div>
                        </div>

                        <div>

                            <h3>Why Hire Me:</h3>

                            <div>

                                Expertise in MERN Stack: My proficiency in the MERN stack enables me to build robust,
                                feature-rich, and user-friendly web applications that cater to your specific
                                requirements.
                                Problem Solver: I possess a keen eye for detail and a tenacious attitude when it comes
                                to
                                tackling challenges. I thrive in finding creative and effective solutions to complex
                                problems.
                                Strong Communicator: As a freelancer, clear and concise communication is key. I take
                                pride
                                in my ability to actively listen to your needs, offer valuable insights, and keep you
                                updated throughout the development process.
                                Timely Delivery: Meeting deadlines is crucial in the fast-paced world of freelancing,
                                and
                                you can count on me to deliver high-quality results on time.

                            </div>
                        </div>

                        <div>

                            <h3>Let's Collaborate:</h3>
                            <div>

                                If you're looking for a reliable and dedicated full-stack developer to turn your ideas
                                into
                                reality, I'd love to work with you. Whether you need a full-fledged web application,
                                customizations, or any other web-related task, I am ready to take on the challenge.
                                Let's
                                discuss your project and how I can contribute to its success.
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default AboutUs;
